import { LayoutAxis } from 'plotly.js';
import { deepFreeze } from '../deep-freeze';

/**
 * Default tickformatstops for the x-axis of a plotly plot.
 *
 * Each `dtickrange` has it's `enabled`-property set to `true` by default.
 */
export const tickformatstopsBase: LayoutAxis['tickformatstops'] = deepFreeze([
  { dtickrange: [0, 1000], value: '%Hh %Mm %Ss %Lms\nday %-j', enabled: true },
  { dtickrange: [1000, 60000], value: '%Hh %Mm %Ss\nday %-j', enabled: true },
  { dtickrange: [60000, null], value: '%Hh %Mm\nday %-j', enabled: true },
  // default value that matches always, for the case that the axis' `dtick` value is undefined
  { dtickrange: [null, null], value: '%Hh %Mm\nday %-j', enabled: true }
]);
